import { Colors, FInter, FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';

const ProjectScoreTitle = styled(FInter.SectionTitle)`
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.02em;
    color: ${Colors.zelWhite100};

    & span {
        font-style: normal;
        font-weight: bold;
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -0.02em;
        color: ${Colors.zelWhite100};
        margin-left: 24px;
    }
`;

const VotingBox = styled(FlexBox)`
    background-color: ${Colors.zelWhite100};
    color: ${Colors.galBlack100};
    min-height: 112px;
    padding: 41px 48px;
    margin-bottom: 16px;
`;

const VotingTitle = styled(FInter.TextDiv)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.02em;
    margin-right: 48px;
`;

const VotingValueBox = styled(FlexBox)`
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    color: #8e9193;
    transition: 0.2s all;

    &:hover {
        color: ${Colors.galBlack100};
    }
`;
export const VotingPanel: FC = () => {
    return (
        <>
            <FlexBox offsetBottom={24}>
                <ProjectScoreTitle>
                    Project Score <FInter.Text>4.9 | 3.2</FInter.Text>
                </ProjectScoreTitle>
            </FlexBox>
            {new Array(4).fill(1).map((el, i) => (
              <VotingBox key={i}>
                <VotingTitle>Rate Conception</VotingTitle>
                <FlexBox>
                  {new Array(10).fill(1).map((el, i) => {
                    return <VotingValueBox key={i}>{i + 1}</VotingValueBox>;
                  })}
                </FlexBox>
              </VotingBox>
            ))}
        </>
    );
};
import { Colors, FInter, FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';

const ProjectScoreTitle = styled(FInter.SectionTitle)`
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.02em;
    color: ${Colors.zelWhite100};

    & span {
        font-style: normal;
        font-weight: bold;
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -0.02em;
        color: ${Colors.zelWhite100};
        margin-left: 24px;
    }
`;

const VotingBox = styled(FlexBox)`
    background-color: ${Colors.zelWhite100};
    color: ${Colors.galBlack100};
    min-height: 112px;
    padding: 41px 48px;
    margin-bottom: 16px;
`;

const VotingTitle = styled(FInter.TextDiv)`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.02em;
    margin-right: 48px;
`;

const VotingValueBox = styled(FlexBox)`
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    color: #8e9193;
    transition: 0.2s all;

    &:hover {
        color: ${Colors.galBlack100};
    }
`;
export const VotingPanel: FC = () => {
    return (
        <>
            <FlexBox offsetBottom={24}>
                <ProjectScoreTitle>
                    Project Score <FInter.Text>4.9 | 3.2</FInter.Text>
                </ProjectScoreTitle>
            </FlexBox>
            {new Array(4).fill(1).map((el, i) => (
              <VotingBox key={i}>
                <VotingTitle>Rate Conception</VotingTitle>
                <FlexBox>
                  {new Array(10).fill(1).map((el, i) => {
                    return <VotingValueBox key={i}>{i + 1}</VotingValueBox>;
                  })}
                </FlexBox>
              </VotingBox>
            ))}
        </>
    );
};
